export const orange = {
  800: 'hsla(27, 100%, 47%, 1)',
  700: 'rgba(245, 124, 0, 1)',
  600: 'hsla(33, 100%, 49%, 1)',
  500: 'hsla(36, 100%, 50%, 1)',
  400: 'rgba(255, 167, 38, 1)',
  300: 'rgba(255, 183, 77, 1)',
  100: 'hsla(36, 100%, 85%, 1)',
  50: 'hsla(37, 100%, 94%, 1)',
};

export type OrangePalette = typeof orange;
